export enum SidebarKeys {
  open = 'sidebar-open',
}

export enum UserKeys {
  potentiallyAuthenticatedSession = 'potentiallyAuthenticatedSession',
  i18n = 'i18n',
}
